import type { DeliveryListResponse } from "~/types/api/cart";

/**
 * Доставки «ПВЗ Фаркоп.ру» для Нижнего Новгорода, Кирова, Ульяновска и
 * Петрозаводска, пока их нет в Bitrix: без них в корзине нет блока «Вам нужна
 * установка?».
 *
 * Конфиг — копия «ПВЗ Фаркоп.ру Москва» с другими LOCATION и SHOP_IDS. Своей
 * службы доставки в Bitrix у них нет, поэтому ID только для корзины, а заказ
 * уходит под ID московской доставки (ORDER_DELIVERY_ID, см. useCartOrderLogic):
 * в заказе будет «Способ доставки: ПВЗ Фаркоп.ру Москва», город — в адресе
 * пункта (POINT_INFO).
 *
 * Как только доставку города заведут в Bitrix (customScripts/
 * addInstallCityDeliveries.php), эмуляция для него отключается сама. Когда
 * заведут все — файл удалить.
 */
const CITY_DELIVERIES = [
  {
    ID: "90001",
    NAME: "ПВЗ Фаркоп.ру Нижний Новгород",
    LOCATION: "nn",
    SHOP_IDS: "83",
  },
  {
    ID: "90002",
    NAME: "ПВЗ Фаркоп.ру Киров",
    LOCATION: "kirov",
    SHOP_IDS: "84",
  },
  {
    ID: "90003",
    NAME: "ПВЗ Фаркоп.ру Ульяновск",
    LOCATION: "ulyanovsk",
    SHOP_IDS: "5804",
  },
  {
    ID: "90004",
    NAME: "ПВЗ Фаркоп.ру Петрозаводск",
    LOCATION: "petrozavodsk",
    SHOP_IDS: "",
  },
];

export function withInstallCityDeliveries(
  list: DeliveryListResponse,
): DeliveryListResponse {
  if (!Array.isArray(list)) {
    return list;
  }

  const template = list.find(
    (item) =>
      item.CONFIG?.MAP_LOGIC === "contacts" && item.CONFIG?.LOCATION === "msk",
  );
  if (!template) {
    return list;
  }

  const locations = new Set(list.map((item) => item.CONFIG?.LOCATION));

  return [
    ...list,
    ...CITY_DELIVERIES.filter((city) => !locations.has(city.LOCATION)).map(
      (city) => ({
        ...template,
        ID: city.ID,
        NAME: city.NAME,
        ORDER_DELIVERY_ID: template.ID,
        CONFIG: {
          ...template.CONFIG,
          LOCATION: city.LOCATION,
          SHOP_IDS: city.SHOP_IDS,
        },
      }),
    ),
  ];
}
